module.exports = __webpack_public_path__ + "assets/img/banner9.5aa923ff.png";